module.exports = __webpack_public_path__ + "slide5-release-ie11.f85bb0faf6056defd2fefa9c805860b9.hashedasset.svg";